export const alertVariants = {
  information: 'infomation',
  success: 'success',
  warning: 'warning',
  alert: 'alert',
};

export const defaultAlertVariant = alertVariants.information;
